import PropTypes from 'prop-types';
import { MIN_PASSWORD_REQUIREMENTS_TEXT } from '~/helpers/constants';

const CreateAccountForm = ({
  createAccountDisabled,
  createAccountValidationState,
  email,
  handleCreateAccountSubmit,
  handleNameChange,
  handlePasswordChange,
  handlePasswordConfirmationChange,
}) => (
  <div>
    <h2 className="reset-header">Create your account</h2>
    <form id="createAccountForm" onSubmit={handleCreateAccountSubmit}>
      <fieldset>
        <label className="text-input-label" htmlFor="userName">
          FULL NAME
          <input id="userName" onChange={handleNameChange} type="username" />
        </label>
        <label className="text-input-label" htmlFor="email">
          EMAIL
          <input id="email" type="email" value={email} readOnly />
        </label>
        <label className="text-input-label" htmlFor="resetPassword">
          PASSWORD
          <input id="resetPassword" type="password" onChange={handlePasswordChange} />
        </label>
        <label className="text-input-label" htmlFor="passwordConfirmation">
          PASSWORD CONFIRMATION
          <input id="passwordConfirmation" type="password" onChange={handlePasswordConfirmationChange} />
        </label>
        <h3 className="min-requirements">
          <br />
          {MIN_PASSWORD_REQUIREMENTS_TEXT}
        </h3>
        <div className="submit-container">
          <button
            className={`icon-arrow-circle ${createAccountValidationState}`}
            disabled={createAccountDisabled}
            id="resetSubmitButton"
            onClick={handleCreateAccountSubmit}
            type="submit"
            value=""
          >
            <span className="submit-text">Create account&nbsp;</span>
          </button>
        </div>
      </fieldset>
    </form>
  </div>
);

CreateAccountForm.propTypes = {
  createAccountDisabled: PropTypes.string.isRequired,
  createAccountValidationState: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  handleCreateAccountSubmit: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  handlePasswordConfirmationChange: PropTypes.func.isRequired,
};

export default CreateAccountForm;
